import { useApiaComponentContext } from '../../apiaComponent/ApiaComponentContext';
import { useApiaFormContext } from '../../page/ApiaForm';
import usePropsSelector from '../../../../../store/propsStore/usePropsSelector';

export default function useStoreProps() {
  const { isFormReadOnly } = useApiaFormContext();
  const fieldProps = useApiaComponentContext();
  const noModify = usePropsSelector(
    fieldProps.fieldId,
    (e) => e.noModify || isFormReadOnly,
  );

  return {
    noModify,
    fieldId: fieldProps.fieldId,
  };
}
